import { BlobProvider } from "@react-pdf/renderer";
import PdfDocumentDutyFree from "../PdfDocumentDutyFree";

const DocumentPreviewDutyFree = ({ data }) => (
  <BlobProvider document={<PdfDocumentDutyFree data={data} />}>
    {({ url, loading, error }) =>
      loading ? (
        <div>Loading PDF...</div>
      ) : error ? (
        <div>Error generating PDF: {error.message}</div>
      ) : (
        <iframe src={url} style={{ width: "100%", height: "500px" }} title="PDF Preview"></iframe>
      )
    }
  </BlobProvider>
);
export default DocumentPreviewDutyFree;